export default {
      id: "unknown-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#unknown",
      toString: function () {
        return this.url;
      }
    }